import React from 'react';
import { motion } from 'framer-motion';

const reviewsData = [
  {
    name: 'Krisztián Jámbrik',
    rating: 5,
    text: 'Itt minden kapható, nehéz lenne felsorolni is. A szerszámoktól meg kezdve a lakberendezésen át szinte minden is kapható!',
    date: '3 éve',
  },
  {
    name: 'Szilágyi Péter',
    rating: 5,
    text: 'Legjobb árak, kedves kiszolgálás! Mindenkinek ajánlom!',
    date: '5 éve',
  },
  {
    name: 'István Nagy',
    rating: 5,
    text: 'Minden van. Csak ajánlani tudom! 😊',
    date: '5 hónapja',
  },
  {
    name: 'Attila Fejes',
    rating: 5,
    text: 'Nagyon jó hely, ajánlani tudom csak mindenkinek. Korrekt árak, udvarias kiszolgálás.',
    date: '8 éve',
  },
  {
    name: 'Timea Vass',
    rating: 5,
    text: 'Nagyon széles választék van. Minden volt amit szerettem volna. 👍👍👍',
    date: '3 éve',
  },
  {
    name: 'Dominik Szabolcs',
    rating: 5,
    text: 'Az eladók nagyon barátságosak, segítőkészek. Széles sávú a választék.',
    date: '7 éve',
  },
];

export default function Reviews() {
  return (
    <section className="py-16 md:py-24 bg-[var(--color-bg)]">
      <div className="mx-auto max-w-[var(--container-max)] px-4">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="text-sm font-semibold text-[var(--color-accent)] uppercase tracking-wider mb-3">
            Vélemények
          </div>
          <h2 className="text-3xl md:text-4xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] tracking-tight mb-6">
            Ügyfeleink mondták
          </h2>

          {/* Google Rating Badge */}
          <a
            href="https://www.google.com/search?q=XL+bútor+Kisvárda#lrd=0x4739a7ca27fd11a3:0x8f4e4c8c8c8c8c8c,1"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-6 py-3 bg-white rounded-full shadow-[var(--shadow-subtle)] md:hover:shadow-[var(--shadow-md)] md:hover:scale-105 transition-all duration-200 cursor-pointer"
            title="Nézd meg összes Google véleményünket"
          >
            <span className="text-2xl">⭐</span>
            <div className="text-left">
              <div className="text-2xl font-bold text-[var(--color-text-primary)]">4.8</div>
              <div className="text-xs text-[var(--color-text-secondary)]">321 vélemény</div>
            </div>
            <span className="text-xl">🟦</span>
          </a>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {reviewsData.map((review, index) => (
            <motion.div
              key={index}
              initial={false}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-[var(--shadow-subtle)] md:hover:shadow-[var(--shadow-md)] transition-shadow duration-200"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <span key={i} className="text-[var(--color-accent)] text-xl">★</span>
                ))}
              </div>

              {/* Review Text */}
              <p className="text-[var(--color-text-secondary)] leading-relaxed mb-6 italic">
                "{review.text}"
              </p>

              {/* Author */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div>
                  <div className="font-semibold text-[var(--color-text-primary)]">{review.name}</div>
                  <div className="text-sm text-[var(--color-text-secondary)]">{review.date}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

